import { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

import type { GebiedLabel } from '@models/GebiedLabel'

import { PropertyRow } from '../../../theme/components/PropertyRow'
import { StyledError } from '../../../theme/components/StyledError'
import { useCreateLabel } from '../../hooks/useCreateLabel'

export { CreateLabel }

type Props = {
  labels: GebiedLabel[]
  onClose: () => void
}

const CreateLabel = ({ labels, onClose }: Props) => {
  const { mutate: createLabel, error } = useCreateLabel()

  const [label, setLabel] = useState('')
  const [errorText, setErrorText] = useState('')

  const { projectType, verantwoordelijke, gebiedscode, gebiedscodeLabel } =
    labels[0]

  const handleSubmit = () => {
    if (!label) {
      setErrorText('Label is verplicht')

      return
    }

    createLabel(
      {
        label: {
          projectType,
          verantwoordelijke,
          gebiedscode,
          label,
        },
      },
      { onSuccess: onClose },
    )
  }

  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Label toevoegen</DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <PropertyRow label="Verantwoordelijke" value={verantwoordelijke} />

        <PropertyRow label="Gebied" value={gebiedscodeLabel} />

        <TextField
          label="Label"
          value={label}
          onChange={(e) => {
            setLabel(e.target.value)
            setErrorText('')
          }}
          variant="standard"
          error={!!errorText}
          helperText={errorText}
        />

        <StyledError error={error} />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Sluiten
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          endIcon={<AddIcon />}
        >
          Toevoegen
        </Button>
      </DialogActions>
    </Dialog>
  )
}
